export const PERMS = {
    READ: 'vehicle_messages.read',
    UPDATE: 'vehicle_messages.update',
    DELETE: 'vehicle_messages.delete',
    CREATE: 'vehicle_messages.create',
    WRITE: 'vehicle_messages.write',
}
